<template>
    <b-container>
        <b-form @submit.prevent="doSearch" autocomplete="off">
            <b-row>
                <b-col xs="12">
                    <b-form-input
                        type="text"
                        placeholder="Código"
                        v-model="code">
                    </b-form-input>
                </b-col>
            </b-row>
            <b-row class="mt-2">
                <b-col xs="12">
                    <b-form-input
                        type="text"
                        placeholder="NIF"
                        v-model="nif">
                    </b-form-input>
                </b-col>
            </b-row>
            <b-row class="mt-2">
                <b-col xs="12">
                    <b-form-input
                        type="text"
                        placeholder="Teléfono"
                        v-model="phone">
                    </b-form-input>
                </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col xs="12">
                <b-form-input
                  type="email"
                  placeholder="Email"
                  v-model="email">
                </b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-2">
                <b-col xs="12" class="d-flex flex-row-reverse">
                    <button
                        type="submit"
                        class="btn btn-brand btn-primary"
                        :disabled="!validForm">
                        <i class="fa fa-search"></i>
                    </button>
                </b-col>
            </b-row>

        </b-form>

        <b-modal
            ref="memberSearchResults"
            hide-footer
            size="md"
            title="Resultados de la búsqueda"
            centered>
            <template v-if="!!members && members.length > 0">
                <b-list-group class="m-2">
                    <b-list-group-item
                        v-for="member in members"
                        :key="member.uuid"
                        href="#"
                        class="d-flex justify-content-between align-items-center"
                        @click="submitMember(member)">
                        <b>{{ member.code }}</b>
                        <div class="d-flex flex-column justify-content-between align-items-end">
                            <div>{{ member.name }} {{ member.surname }}</div>
                            <div><small>{{ member.nif }}</small></div>
                        </div>
                    </b-list-group-item>
                </b-list-group>
            </template>
            <template v-else>
                <p class="my-3 text-center">
                    No hay resultados
                </p>
            </template>
        </b-modal>
    </b-container>
</template>

<script>
    import {searchMembers} from '@/api/member-api';

    export default {
        name: "member-search-small",
        data: function () {
            return {
                code: null,
                nif: null,
                phone: null,
                email: null,
                members: null
            };
        },
        computed: {
            validForm() {
                return (!!this.code || !!this.nif || this.phone || this.email)
            }
        },
        methods: {
            async doSearch() {
                if (this.validForm) {
                    this.$_loadingMixin_showLoading();
                    await searchMembers({
                        code: this.code,
                        nif: this.nif,
                        phone: this.phone,
                        email: this.email,
                        includeUnlinkedMembers: true
                    })
                        .then((members) => {
                            if (members.length === 1) {
                                this.submitMember(members[0])
                            } else {
                                this.setUpSearchResults(members);
                            }
                        })
                        .catch(() => {
                            this.setUpSearchResults([]);
                        });
                    this.$_loadingMixin_hideLoading();
                }
            },
            setUpSearchResults(members) {
                this.$refs.memberSearchResults.show();
                this.members = members;
            },
            submitMember(member) {
                let resultMember = JSON.parse(JSON.stringify(member));
                if (resultMember.hasOwnProperty('unlinkedMembers') && resultMember.unlinkedMembers.length) {
                    let resultUnlinkedMember;

                    for (let i = 0; i < resultMember.unlinkedMembers.length; i++) {
                        if (resultMember.unlinkedMembers[i] && resultMember.unlinkedMembers[i].hasOwnProperty('nif') && resultMember.unlinkedMembers[i].nif == this.nif) {
                            resultUnlinkedMember = resultMember.unlinkedMembers[i];
                            break;
                        }
                    }

                    if (resultUnlinkedMember) {
                        resultMember['unlinkedMember'] = resultUnlinkedMember;
                    }
                }

                this.code = null;
                this.nif = null;
                this.phone = null;
                this.email = null;
                this.$refs.memberSearchResults.hide();
                this.$emit('submit-member', resultMember);
            }
        }
    }
</script>

<style scoped>

</style>
